const stilePulsanti = {
  buttonClassesWhite:
    "tastoBianco f6-ns link dim ba ph3 pv2 dib br3 bordoColAlt mr2 pointer",
  buttonClassesWhiteRound:
    "tastoBianco f6-ns link dim ba ph3 pv2 dib br-100 bordoColAlt mr2 pointer",
  buttonClassesWhiteNoBorder:
    "tastoBianco f6-ns link dim ba ph3 pv2 dib br3 sfondoBiancoTema mr2 pointer",
  buttonClassesRed:
    "tastoRosso f6-ns link dim ba ph3 pv2 dib white br3 mr2 pointer",
  buttonClassesOrange:
    "tastoArancio f6-ns link dim ba ph3 pv2 dib white br3 mr2 pointer",
  buttonClassesGreen:
    "tastoVerde f6-ns link dim ba ph3 pv2 dib white br3 mr2 pointer",
  buttonClassesAttesa:
    "colAttesa f6-ns link dim ba ph3 pv2 dib white br3 mr2 pointer",
  inputClasses: "db w-100 measure ba bordoColScrittaDef-10 pa2 br2 mb2",
  inputClassesNoMeasure: "db w-100 ba bordoColScrittaDef-10 pa2 br2 mb2",
  inputClassesThird: "db w-third measure ba bordoColScrittaDef-10 pa2 br2 mb2",
  inputClassesConTasto:
    "w-75 w-75-m w-80-l ba bordoColScrittaDef-10 pa2 br2-ns mb2 br--left-ns",
  inputClassesConDueTasti:
    "w-50 w-50-m w-80-l ba bordoColScrittaDef-10 pa2 br2-ns mb2 br--left-ns",
  inputClassesConTreTasti:
    "w-30 w-30-m w-40-l ba bordoColScrittaDef-10 pa2 br2-ns mb2 br--left-ns",
  inputClassesRicercaOrizzontale:
    "db ml3 mr3 measure ba bordoColScrittaDef-10 pa2 br2 ",
  inputClassesNOW: "ba bordoColScrittaDef-10 pa2 br2-ns mb2 br--left-ns",
  tastoRicercaOrizzontale:
    "f6-ns link dim ba dib pa2 br3 bordoColAlt sfondoBiancoTema mr2 pointer fw6",
  spazioTestoConTasto: "w-75 w-75-m w-80-l pa2 br2-ns mb2 br--left-ns",
  classiTastoBlocco:
    "tastiVicinoInput button-reset tooltip border-box bg-yellow scrittaDef pointer ba bordoColScrittaDef-10 w-25 w-25-m w-20-l br2-ns br--right-ns bordoColScrittaDef-10",
  classiTastoSblocco:
    "tastiVicinoInput button-reset tooltip border-box sfondoBiancoTema scrittaDef pointer ba bordoColScrittaDef-10 w-25 w-25-m w-20-l br2-ns br--right-ns bordoColScrittaDef-10",
  classiTastoSbloccoVerde:
    "tastoVerde tastiVicinoInput button-reset tooltip border-box scrittaDef pointer ba bordoColScrittaDef-10 w-25 w-25-m w-20-l br2-ns br--right-ns bordoColScrittaDef-10",
  classiTastoCopiaInAlto:
    "tastiVicinoInput button-reset tooltip border-box sfondoBiancoTema scrittaDef pointer ba bordoColScrittaDef-10",
  tastoQuadratoVerde:
    "tastoVerde tastiVicinoInput button-reset tooltip border-box white pointer ba bordoColScrittaDef-10  bordoColScrittaDef-10",
  tastoQuadratoGiallo:
    "tastoArancio tastiVicinoInput button-reset tooltip border-box scrittaDef pointer ba bordoColScrittaDef-10  bordoColScrittaDef-10 b",
  tastoQuadratoRosso:
    "tastoRosso tastiVicinoInput button-reset tooltip border-box white pointer ba bordoColScrittaDef-10  bordoColScrittaDef-10",
  tastoQuadratoBianco:
    "tastoBianco tastiVicinoInput button-reset tooltip border-box scrittaDef pointer ba bordoColScrittaDef-10  bordoColScrittaDef-10",
  tastoQuadratoArrBianco:
    "tastoBianco tastiVicinoInput button-reset tooltip border-box scrittaDef br3 pointer ba bordoColScrittaDef-10  bordoColScrittaDef-10",
  vociMenuTabs:
    "pointer pl2 pt2 pb2 togliSpazi flex items-center nonSelezionabile",
  vociMenuTabsSelezionata:
    "vociMenuTabsSelezionata pl2 pt2 pb2 togliSpazi flex items-center nonSelezionabile",
  classeDatiPiccoli: "w-20 ba bordoColScrittaDef-10 pa2 br2 ml2 mr2 mb2",
  classiTastoCopia:
    "tastiVicinoInput h-50 pa2 br3 button-reset tooltip border-box sfondoBiancoTema scrittaDef pointer ba bordoColScrittaDef-10",
  tastoCopiaAspetto: (
    <div className="material-icons colScrittaDef-20">content_copy</div>
  ),
  tastoCercaAspetto: (
    <div className="material-icons colScrittaDef-20">search</div>
  ),
  tastoSXAspetto: <div className="material-icons">chevron_left</div>,
  tastoDXAspetto: <div className="material-icons">chevron_right</div>,
  tastoCercaAvanzataAspetto: (
    <div className="material-icons colScrittaDef-20">manage_search</div>
  ),
  tastoErroreAspetto: (
    <div className="material-icons colScrittaDef-20">error</div>
  ),
  tastoWarningAspetto: (
    <div className="material-icons colScrittaDef-20">warning</div>
  ),
  tastoNuovoAspetto: <div className="material-icons colScrittaDef-20">add</div>,
  tastoImportAspetto: (
    <div className="material-icons colScrittaDef-20">download</div>
  ),
  tastoExportAspetto: (
    <div className="material-icons colScrittaDef-20">file_upload</div>
  ),
  tastoForzaAspetto: (
    <div className="material-icons colScrittaDef-20">bolt</div>
  ),
  tastoRefreshAspetto: (
    <div className="material-icons colScrittaDef-20">cached</div>
  ),
  tastoSwitchaAspetto: (
    <div className="material-icons colScrittaDef-20">autorenew</div>
  ),
  tastoCancellaAspetto: (
    <div className="material-icons colScrittaDef-20">delete</div>
  ),
  tastoCancellaAspettoAlt: <div className="material-icons">delete_forever</div>,
  tastoImmagineAspetto: <div className="material-icons">image</div>,
  tastoCercaAvanzataAspettoScuro: (
    <div className="material-icons">manage_search</div>
  ),
  tastoTestoAspetto: <div className="material-icons">menu_book</div>,
  tastoApriAspetto: (
    <div className="material-icons colScrittaDef-20">open_in_new</div>
  ),
  bloccoTradAspetto: (
    <div className="material-icons colScrittaDef-20">lock</div>
  ),
  tastoChiudiAspetto: (
    <div className="material-icons colScrittaDef-20">close</div>
  ),
  tastoSalvaAspetto: (
    <div className="material-icons colScrittaDef-20">save</div>
  ),
  tastoStampaAspetto: (
    <div className="material-icons colScrittaDef-20">print</div>
  ),
  tastoSalvaChiudiAspetto: (
    <div>
      <span className="material-icons colScrittaDef-20">save</span>
      <span className="material-icons colScrittaDef-20">close</span>
    </div>
  ),
  tastoToolsAspetto: (
    <div className="material-icons colScrittaDef-20">construction</div>
  ),
  tastoHomeAspetto: <div className="material-icons">home</div>,
  tastoArticoliAspetto: <div className="material-icons">roller_skating</div>,
  tastoContabiliAspetto: <div className="material-icons">account_balance</div>,
  tastoNoteAspetto: <div className="material-icons">description</div>,
  tastoAtteseAspetto: <div className="material-icons">schedule</div>,
  tastoInviaAspetto: <div className="material-icons">send</div>,
  tastoGaranzieAspetto: <div className="material-icons">hardware</div>,
  tastoPiuAspetto: <div className="material-icons">add</div>,
  tastoMenoAspetto: <div className="material-icons">remove</div>,
  tastoEvasioneAspetto: (
    <div className="material-icons">shopping_cart_checkout</div>
  ),
  tastoVistaAspetto: (
    <div className="material-icons colScrittaDef-20">visibility</div>
  ),
  tastoCodiceAspetto: (
    <div className="material-icons colScrittaDef-20">code</div>
  ),
  tastoVistaCodiceAspetto: (
    <div className="">
      <span className="material-icons colScrittaDef-20">visibility</span>
      <span className=" colScrittaDef-20"> / </span>
      <span className="material-icons colScrittaDef-20">code</span>
    </div>
  ),
  tastoCaricaAspetto: (
    <div className="material-icons colScrittaDef-20">folder_open</div>
  ),
  tastoResetAspetto: (
    <div className="material-icons colScrittaDef-20">clear</div>
  ),
  tastoFulmineAspetto: (
    <div className="material-icons colScrittaDef-20">bolt</div>
  ),
  tastoSopraAspetto: <div className="material-icons ">keyboard_arrow_up</div>,
  tastoSottoAspetto: <div className="material-icons ">keyboard_arrow_down</div>,
  riquadroClassesRed: "tastoRosso f6-ns ba ph3 pv2 dib white br3 mr2",
  riquadroClassesGreen: "tastoVerde f6-ns ba ph3 pv2 dib white br3 mr2",
};

export default stilePulsanti;
